import { render, staticRenderFns } from "./AdItemVideo.vue?vue&type=template&id=06672232&"
import script from "./AdItemVideo.vue?vue&type=script&lang=ts&"
export * from "./AdItemVideo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports